export default __webpack_public_path__ + "static/cat1-ac4d3e0912e96c645a506af0f8cdff28.png";